import { i as isBefore, b as isAfter } from './subMonths.js';

// src/module/format/date/index.ts
function dateToDateString(input) {
  if (!input) {
    return void 0;
  }
  if (typeof input === "string") {
    if (isValidDateString(input) || isValidDateTimeString(input)) {
      return input.substring(0, 0 + 10);
    }
    return void 0;
  }
  return [input.getFullYear(), input.getMonth() + 1, input.getDate()].map((v) => `${v}`.padStart(2, "0")).join("-");
}
function isValidDateTimeString(input) {
  if (typeof input === "undefined") {
    return false;
  }
  let [date, time] = input.split("T");
  time = time?.replace(/(Z)|((\+|-)\d{2}:\d{2})$/gm, "");
  return isValidDateString(date) && isValidTimeString(time);
}
function isValidDateString(input) {
  if (typeof input === "undefined" || input === null) {
    return false;
  }
  const parts = input.split("-");
  if (parts.length !== 3) {
    return false;
  }
  const [y, m, d] = parts;
  if (!(y.length === 4 && +y > 0)) {
    return false;
  }
  if (!(m.length === 2 && +m > 0 && +m <= 12)) {
    return false;
  }
  if (!(d.length === 2 && +d > 0 && +d <= 31)) {
    return false;
  }
  return true;
}
function isValidTimeString(input) {
  if (typeof input === "undefined" || input === null) {
    return false;
  }
  if (input.match(/(Z)|((\+|-)\d{2}:\d{2})$/gm) !== null) {
    return false;
  }
  const parts = input.split(":");
  if (
    // inline type-guard
    !((p) => {
      return p.length === 2 || p.length === 3;
    })(parts)
  ) {
    return false;
  }
  const [h, m, _s] = parts;
  if (!(h.length === 2 && +h < 24)) {
    return false;
  }
  if (!(m.length === 2 && +m < 60)) {
    return false;
  }
  if (_s) {
    const [s, ms] = _s.split(".");
    if (!(s.length === 2 && +s < 60)) {
      return false;
    }
    if (ms) {
      if (!(ms.length === 3 && +ms < 1e3)) {
        return false;
      }
    }
  }
  return true;
}

const parseValue = (val) => {
    if (typeof val === 'undefined') {
        return;
    }
    const [start, end] = JSON.parse(val);
    const startValid = start === null || isValidDateString(start);
    const endValid = end === null || isValidDateString(end);
    if (!(startValid && endValid)) {
        throw new Error('Invalid date values');
    }
    return [start, end];
};
const stringifyValue = (range) => {
    const [start, end] = range;
    return JSON.stringify([start, end]);
};
const getNewValue = (idx, newDate, currentValue) => {
    let newValue = [null, null];
    try {
        newValue = parseValue(currentValue) ?? [null, null];
    }
    catch (err) {
        // ignore bad values
    }
    // Update given idx with new Date object
    newValue[idx] = newDate || null;
    return newValue;
};
function checkDateBounds({ date, pos, minDate, maxDate, }) {
    // Nothing to check if date is undefined
    if (!date) {
        return;
    }
    // If we can compare to minDate
    if (typeof minDate !== 'undefined') {
        if (date !== minDate && isBefore(new Date(date), new Date(minDate))) {
            throw new Error(`The ${pos} date may not be before the min date.`);
        }
    }
    // If we can compare to maxDate
    if (typeof maxDate !== 'undefined') {
        if (date !== maxDate && isAfter(new Date(date), new Date(maxDate))) {
            throw new Error(`The ${pos} date may not be after the max date.`);
        }
    }
}
function checkDateOverlaps(startDate, endDate) {
    // Nothing to check if we don't have both dates
    if (!(startDate && endDate)) {
        return;
    }
    // Dates may be on the same day
    if (startDate === endDate) {
        return;
    }
    // If end date is before start date
    if (isBefore(new Date(endDate), new Date(startDate))) {
        throw new Error(`The end date may not be before the start date.`);
    }
}

export { checkDateBounds as a, checkDateOverlaps as c, dateToDateString as d, getNewValue as g, parseValue as p, stringifyValue as s };

//# sourceMappingURL=util3.js.map